export default __webpack_public_path__ + "static/media/arrownext.2d7343f1.svg";